export const environment = {
    production: false,
    apiUrl: 'https://rewardsservices.griris.net/clientportal/',
    secretAesKey: 'eJ+VCJ0auu9Fx+GsyjBVm9pIPHjjU2xl01rt78naWbM=',
     clientTemplateDomain:"https://rewardsservices.griris.net/",
     blobExcelDomain: "https://esgglririsimagestorea.blob.core.windows.net/procurement-catalog/ExcelFolder/",
     OrderExcelDomain: "https://esgglririsimagestorea.blob.core.windows.net/procurement-catalog/",
 
 };
  